import { render, staticRenderFns } from "./BookingsAcknowledge.vue?vue&type=template&id=28a85636"
import script from "./BookingsAcknowledge.vue?vue&type=script&lang=js"
export * from "./BookingsAcknowledge.vue?vue&type=script&lang=js"
import style0 from "./BookingsAcknowledge.vue?vue&type=style&index=0&id=28a85636&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a85636')) {
      api.createRecord('28a85636', component.options)
    } else {
      api.reload('28a85636', component.options)
    }
    module.hot.accept("./BookingsAcknowledge.vue?vue&type=template&id=28a85636", function () {
      api.rerender('28a85636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/BookingsAcknowledge.vue"
export default component.exports